// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --Orange: #fe6100;
  --Green: #87bc45;
  --Red: #e00606;
  --WhiteSmoke: #f5f5f5;
  --White: #fff;
  --StockOrange: #ff7b29;
  --StockRed: #e00606;
  --SaddleBrown: #833505;
  --TotalBlack: #000000;
  --HightEmphasis: #212121;
  --LightBlack: #0f1d3e;
  --MediumEmphasis: #666;
  --LowEmphasis: #9e9e9e;
  --Gray88: #e0e0e0;
  --Gray85: #d9d9d9; }

.companyCard_container__hUWdG {
  display: flex;
  gap: 22px;
  width: 380px;
  max-width: calc(33% - 67px);
  height: 90px;
  padding: 10px 14px;
  background-color: var(--White);
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  cursor: pointer;
  align-items: center; }
  .companyCard_container__hUWdG .companyCard_logo_box__0mfDK {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 58px;
    width: 64px; }
    .companyCard_container__hUWdG .companyCard_logo_box__0mfDK .companyCard_logo__ibPNJ {
      max-width: 100%;
      max-height: 58px; }
  .companyCard_container__hUWdG .companyCard_infoContainer__xTQI6 {
    display: flex;
    flex-direction: column;
    justify-content: space-between; }
    .companyCard_container__hUWdG .companyCard_infoContainer__xTQI6 h5 {
      font-weight: 600;
      font-size: 14px;
      line-height: 150%;
      line-height: 24px; }
    .companyCard_container__hUWdG .companyCard_infoContainer__xTQI6 span {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: var(--LowEmphasis); }
`, "",{"version":3,"sources":["webpack://./src/styles/colors.scss","webpack://./src/components/companyCard/companyCard.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAAA;EAEE,iBAAS;EACT,gBAAQ;EACR,cAAM;EACN,qBAAa;EACb,aAAQ;EACR,sBAAc;EACd,mBAAW;EACX,sBAAc;EAGd,qBAAa;EACb,wBAAgB;EAChB,qBAAa;EACb,sBAAiB;EACjB,sBAAc;EAGd,iBAAS;EACT,iBAAS,EAAA;;ACjBX;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB,EAAA;EAXrB;IAcI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW,EAAA;IAlBf;MAoBM,eAAe;MACf,gBAAgB,EAAA;EArBtB;IA0BI,aAAa;IACb,sBAAsB;IACtB,8BAA8B,EAAA;IA5BlC;MCsBE,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MDQb,iBAAiB,EAAA;IAhCvB;MCwCE,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MDLb,yBAAyB,EAAA","sourcesContent":[":root {\n  // Product\n  --Orange: #fe6100;\n  --Green: #87bc45;\n  --Red: #e00606;\n  --WhiteSmoke: #f5f5f5;\n  --White: #fff;\n  --StockOrange: #ff7b29;\n  --StockRed: #e00606;\n  --SaddleBrown: #833505;\n\n  // On Surface\n  --TotalBlack: #000000;\n  --HightEmphasis: #212121;\n  --LightBlack: #0f1d3e;\n  --MediumEmphasis: #666;\n  --LowEmphasis: #9e9e9e;\n\n  // Border\n  --Gray88: #e0e0e0;\n  --Gray85: #d9d9d9;\n}\n","@import '../../styles/colors.scss';\n@import '../../styles/fonts.scss';\n\n.container {\n  display: flex;\n  gap: 22px;\n  width: 380px;\n  max-width: calc(33% - 67px);\n  height: 90px;\n  padding: 10px 14px;\n  background-color: var(--White);\n  border: 1px solid #E0E0E0;\n  border-radius: 4px;\n  cursor: pointer;\n  align-items: center;\n\n  .logo_box {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 58px;\n    width: 64px;\n    .logo {\n      max-width: 100%;\n      max-height: 58px;\n    }\n  }\n\n  .infoContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    h5 {\n      @include h5;\n      line-height: 24px;\n    }\n\n    span {\n      @include body2;\n      color: var(--LowEmphasis);\n    }\n  }\n}\n\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `companyCard_container__hUWdG`,
	"logo_box": `companyCard_logo_box__0mfDK`,
	"logo": `companyCard_logo__ibPNJ`,
	"infoContainer": `companyCard_infoContainer__xTQI6`
};
export default ___CSS_LOADER_EXPORT___;
